import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const ThemeContext = createContext({ theme: "dark", toggle: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("ud_theme") || "dark");
  const { pathname } = useLocation();

  useEffect(() => {
    const light = theme === "light" && !pathname.startsWith("/admin");
    document.documentElement.classList.toggle("light", light);
    localStorage.setItem("ud_theme", theme);
  }, [theme, pathname]);

  const toggle = () => setTheme((t) => (t === "light" ? "dark" : "light"));
  return <ThemeContext.Provider value={{ theme, toggle }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
